(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("onlineExamActivationsHistory", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/evaluations/onlineExams/onlineExamActivationsHistoryView.html",
            controller: ["onlineExamsHistoryResource", "messageService", "$filter", "$scope", "$translate", "$state", "DTOptionsBuilder", "$q", "$compile", "$uibModal", OnlineExamActivationsHistoryCtrl],
            controllerAs: "vm"
        };
        function OnlineExamActivationsHistoryCtrl(onlineExamsHistoryResource, messageService, $filter, $scope, $translate, $state, DTOptionsBuilder, $q, $compile, $uibModal) {
            var vm = this;
            vm.code = $state.params.code;
            vm.person = $state.params.person;
            vm.activationNumber = parseInt($state.params.activationNumber);
            vm.assignmentId = parseInt($state.params.assignmentId);
            vm.isLoading = true;
            vm.noMoreAttempts = true; //for testing
            onlineExamsHistoryResource.getActivationsDetails({ code: vm.code, person: vm.person }, function (data) {
                vm.pageHeader = data.userFullName + " - " + data.learningItemName + " " + $translate.instant("evaluations.onlineExams.history");
                vm.isLoading = false;
            }, function (error) {
                messageService.error(error);
            });
            vm.getExamAttemptsHistory = function (activationNumber) {
                if (activationNumber)
                    vm.activationNumber = activationNumber;
                vm.lang = $translate.proposedLanguage() || $translate.use();
                vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                    return $q(function (resolve) {
                        var promise = onlineExamsHistoryResource.get({ person: vm.person, assignmentId: vm.assignmentId, activationNumber: vm.activationNumber }).$promise;
                        promise.then(function (data) {
                            vm.summary = data.summary;
                            vm.allPossibleResults = data.allPossibleResults;
                            resolve(data.history);
                        });
                    });
                })
                    .withOption("createdRow", function (row) {
                    // Recompiling so we can bind Angular directive to the DT
                    $compile(angular.element(row).contents())($scope);
                })
                    .withOption("headerCallback", function (header) {
                    if (!vm.headerCompiled) {
                        // Use this headerCompiled field to only compile header once
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                })
                    .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                    .withOption("processing", true)
                    .withOption("responsive", { details: { type: "column" } })
                    .withOption("stateSave", true)
                    .withOption("stateDuration", -1)
                    .withPaginationType("full_numbers")
                    .withOption("rowCallback", rowCallback)
                    .withOption("order", [1, "desc"])
                    .withBootstrap();
                //modification history
                vm.modificationDtOptions = DTOptionsBuilder.fromFnPromise(function () {
                    return onlineExamsHistoryResource.getAttemptsModificationHistory({ person: vm.person, assignmentId: vm.assignmentId, activationNumber: vm.activationNumber }).$promise;
                })
                    .withOption("createdRow", function (row) {
                    // Recompiling so we can bind Angular directive to the DT
                    $compile(angular.element(row).contents())($scope);
                })
                    .withOption("headerCallback", function (header) {
                    if (!vm.headerCompiled) {
                        // Use this headerCompiled field to only compile header once
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                })
                    .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                    .withOption("processing", true)
                    .withOption("responsive", { details: { type: "column" } })
                    .withOption("stateSave", true)
                    .withOption("stateDuration", -1)
                    .withPaginationType("full_numbers")
                    .withOption("order", [1, "desc"])
                    .withBootstrap();
            };
            if (vm.activationNumber === 0) {
                //The page is loaded directly from the Exam History page - there are no existing activations for this assignment
                vm.noPreviousActivations = true;
            }
            else {
                vm.getExamAttemptsHistory();
            }
            vm.dtColumns = [
                {
                    "data": null,
                    "defaultContent": "",
                    "class": "control",
                    "sortable": false,
                    "targets": 0
                },
                {
                    "data": "number",
                    "title": $translate.instant("common.attempt"),
                    "class": "text-center"
                },
                {
                    "data": "date",
                    "render": function (data) {
                        return data ? moment.utc(data).local().format("MMM DD, Y") : "";
                    },
                    "title": $translate.instant("common.lists.date")
                },
                {
                    "data": null,
                    "render": function (data) {
                        if (data.isManualScore)
                            return "-";
                        return $filter("sbPercentage")(data.passingScore, 2);
                    },
                    "title": $translate.instant("common.passingScore"),
                    "class": "text-center"
                },
                {
                    "data": null,
                    "render": function (data) {
                        return $filter("sbPercentage")(data.score, 2);
                    },
                    "title": $translate.instant("common.lists.score"),
                    "class": "text-center"
                },
                {
                    "data": "result",
                    "render": function (data) {
                        return $translate.instant("common.activationExamStatus." + data);
                    },
                    "title": $translate.instant("common.lists.result")
                },
                {
                    "data": null,
                    "render": function (full) {
                        if (full.isManualScore)
                            return "<span translate='evaluations.onlineExams.attemptsHistory.manual'></span>";
                        return "<a id='viewDetails'  translate='evaluations.onlineExams.attemptsHistory.view' href='' ng-click='vm.viewDetails(" + full.id + ")'></a>";
                    },
                    "title": $translate.instant("common.lists.details"),
                    "class": "text-center",
                    "sortable": false
                }
            ];
            vm.dtInstanceCallback = function (instance) {
                vm.dtInstance = instance;
            };
            vm.modificationDtColumns = [
                {
                    "data": null,
                    "defaultContent": "",
                    "class": "control",
                    "sortable": false,
                    "targets": 0
                },
                {
                    "data": "date",
                    "render": function (data) {
                        return data ? moment.utc(data).local().format("MMM DD, Y h:mm:ss a") : "";
                    },
                    "title": $translate.instant("common.lists.dateTime")
                },
                {
                    "data": null,
                    "render": function (full) {
                        var values = full.modificationValues !== "" ? JSON.parse(full.modificationValues) : "";
                        if (full.modificationKey === "evaluations.onlineExams.attemptsHistory.modificationHistory.resultUpdated") {
                            values["fromValue"] = $translate.instant(values["fromValue"]);
                            values["toValue"] = $translate.instant(values["toValue"]);
                        }
                        return $translate.instant(full.modificationKey, values);
                    },
                    "title": $translate.instant("common.lists.modification")
                },
                {
                    "data": "modifiedBy",
                    "title": $translate.instant("common.lists.modifiedBy")
                },
                {
                    "data": "note",
                    "title": $translate.instant("common.lists.note")
                }
            ];
            vm.modificationDtInstanceCallback = function (instance) {
                vm.modificationDtInstance = instance;
            };
            vm.viewDetails = function (attemptId) {
                var params = { person: vm.person, examAttemptId: attemptId };
                $state.go("main.evaluations.examAttemptsDetails", params);
            };
            function rowCallback(nRow, aData) {
                // Unbind first in order to avoid any duplicate handler
                //(see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                $("td:not(.control)", nRow).bind("click", function (e) {
                    var element = $(e.target);
                    if (element.attr("id") !== "viewDetails") {
                        $scope.$apply(function () {
                            //open edit model
                            var modalInstance = $uibModal.open({
                                templateUrl: "app/evaluations/onlineExams/editExamAttemptView.html",
                                controller: "EditExamAttemptCtrl as vm",
                                scope: $scope,
                                backdrop: "static",
                                resolve: {
                                    attemptData: function () {
                                        return aData;
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                //reload the history and the details
                                vm.dtInstance.reloadData(true);
                                vm.modificationDtInstance.reloadData(true);
                            }).catch(angular.noop);
                        });
                    }
                });
                return nRow;
            }
            vm.goBack = function () {
                if (vm.activationNumber === 0)
                    $state.go("main.evaluations.onlineExam");
                else
                    $state.go("main.evaluations.onlineExamsHistory", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId });
            };
            vm.enterManualScore = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/evaluations/onlineExams/addManualScoreView.html",
                    controller: "AddManualScoreCtrl as vm",
                    scope: $scope,
                    backdrop: "static",
                    resolve: {}
                });
                modalInstance.result.then(function () {
                    //reload the history and the details
                    if (vm.dtInstance && vm.modificationDtInstance) {
                        vm.dtInstance.reloadData(true);
                        vm.modificationDtInstance.reloadData(true);
                    }
                    else {
                        $state.go("main.evaluations.onlineExamAttemptsHistory", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId, activationNumber: 1 }, { reload: true });
                    }
                }).catch(angular.noop);
            };
            vm.addExamAttempts = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/evaluations/onlineExams/modal/onlineExamAddAttemptModalView.html",
                    controller: "OnlineExamAddAttemptModalCtrl as vm",
                    scope: $scope
                });
                modalInstance.result.then(function () {
                    //reload the history and the details
                    vm.dtInstance.reloadData(true);
                    vm.modificationDtInstance.reloadData(true);
                }).catch(angular.noop);
            };
        }
    });
}());
